// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Projects-module__icon--ddU8N>svg {
    font-size: 14px;
}

.Projects-module__icon--ddU8N {
    display: flex
}

.Projects-module__ProductName--jsLOf {
    margin-top: 20px;
    margin-bottom: 20px;
}

.Projects-module__btnContainer--whd_X {
    display: flex;
}`, "",{"version":3,"sources":["webpack://./src/pages/projects/Projects.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".icon>svg {\r\n    font-size: 14px;\r\n}\r\n\r\n.icon {\r\n    display: flex\r\n}\r\n\r\n.ProductName {\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.btnContainer {\r\n    display: flex;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `Projects-module__icon--ddU8N`,
	"ProductName": `Projects-module__ProductName--jsLOf`,
	"btnContainer": `Projects-module__btnContainer--whd_X`
};
export default ___CSS_LOADER_EXPORT___;
